import { defineStore } from 'pinia'

export const useLoadingStore = defineStore('loading', {
  state: () => ({
    isLoading: false,
    timer: null
  }),
  actions: {
    showFor(duration) {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.isLoading = true
      this.timer = setTimeout(() => {
        this.isLoading = false
        this.timer = null
      }, duration)
    },
    hide() {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.isLoading = false
    }
  }
}) 